<template>
  <div style="background-color: #ffffff;">
    <b-row style="padding-top:  25px; padding-bottom: 25px;">
      <b-col cols="4">
        <b-img
            thumbnail
            :src="sweet16ImgURL"
        />
      </b-col>
      <b-col class="text-center" sm>
        <h3>Jan 20, 2024</h3>
        <h4>Reception</h4>
        <h5>6:00 - 8:00 PM</h5>
        <hr />
        <h4>After Party</h4>
        <h5>8:30-10:30 PM</h5>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Home_Main_Row",
  created() {
    this.formReset();
  },
  mounted() {},
  components: {},
  methods: {
    submitRSVP() {
      if (this.simpleValidate().length > 0) return;

      this.$emit("applied", this.formRSVP);
      this.formReset();
    },
    simpleValidate() {
      this.errors = [];

      if (this.formRSVP && !this.validateEmail(this.formRSVP.email))
        this.errors.push("Please enter a valid email");

      if (
        (this.formRSVP && !this.formRSVP.name) ||
        this.formRSVP.name.length === 0
      )
        this.errors.push("Please enter your name");

      return this.errors;
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    formReset() {
      this.formRSVP = null;
      this.formRSVP = this.formDefault;
    }
  },
  data() {
    return {
      sweet16ImgURL:"/assets/_birthday/sweet16.png",
      formRSVP: null,
      formDefault: {
        name: null,
        email: null
      },
      errors: []
    };
  }
};
</script>

<style lang="scss" scoped>
.single {
  max-width: 600px;
  width: 100%;
  // height: 134px;

  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 56px;
  line-height: 120%;
  /* or 67px */

  /* Body */

  color: #222222;
}
.coming-soon__text {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.main-hero {
  //background: url("../../assets/img/home/hero.svg") no-repeat center center;
  //background-size: cover;
  background-color: #fe828c;
  h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    line-height: 55px;
    color: #0d0d21;
    display: flex;
    column-gap: 15px;
    margin-bottom: 16px;
    span {
      font-style: normal;
      font-weight: bold;
      font-size: 20px;
      line-height: 27px;
      display: flex;
      align-items: center;
      color: #ffcc4d;
      margin-top: -5px;
    }
  }
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #f3f6f9;
    margin-bottom: 30px;
  }
  .input-rsvp {
    margin-top: 25px;
    display: flex;
    justify-content: center;
    column-gap: 8px;
    min-height: 50px;
    background-color: #b2ac88;
    border-radius: 15px;
    margin-bottom: 15px;
    & > div {
      width: 100%;
    }
    .error {
      display: inline-block;
      margin-bottom: 6px;
      font-size: 12px;
      margin-left: 10px;
      color: #fff;
    }
    .form-control {
      padding: 12px 27px;
      height: 40px;
      border-radius: 20px;
      border: 1px solid #fff;
      margin: 15px;
      &:focus {
        outline: none;
        border: 1px solid #fff;
      }
      &::-webkit-input-placeholder {
        /* Edge */
        font-size: 12px;
        line-height: 16px;
        color: #8d99a0;
      }

      &:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        font-size: 12px;
        line-height: 16px;
        color: #8d99a0;
      }

      ::placeholder {
        font-size: 12px;
        line-height: 16px;
        color: #8d99a0;
      }
    }
    .btn-success {
      background: #010610;
      border-radius: 32px;
      height: 40px;
      font-style: normal;
      font-weight: bold;
      font-size: 12px;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      padding: 12px 16px;
      min-width: 150px;
      &:after,
      &:before {
        content: none;
      }
    }
  }
  img {
    margin: 40px 0;
  }
}
@media (min-width: 992px) {
  .banner-img {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 25px;
  }
}
@media (max-width: 768px) {
  .coming-soon__text {
    margin-top: 24px;
  }
  .main-hero {
    padding: 44px 0;
    h3 {
      font-size: 24px;
    }
    .input-rsvp {
      display: grid;
      grid-template-columns: 1fr;
      justify-items: start;
      margin-bottom: 12px;
    }
    .single {
      display: contents;
      height: unset;
    }
  }
  .banner-img svg {
    height: 400px;
  }
}
@media (max-width: 640px) {
  .single {
    font-size: 32px;
  }
}
</style>
